<template>
  <el-form
      ref="form"
      :model="form">
    <el-form-item
        v-if="bidInput"
        label="默认竞价"
        prop="bid"
        :label-width="bidLabelWidth">
      <gj-input
          v-model="form.bid"
          width="200px">
        <template #prepend>{{adStore.SP.currencySymbol}}</template>
      </gj-input>
    </el-form-item>
    <el-row
        type="flex"
        class="gj-picker">
<!--      左边-->
      <div class="gj-picker__editor" :style="{width}">
        <el-tabs :value="'first'">
<!--          建议关键词-->
          <el-tab-pane label="建议关键词" name="first">
            <el-form-item
                label="匹配条件"
                style="margin-bottom: 0;padding-left: 12px;">
              <el-checkbox-group
                  v-model="form.matchTypes">
                <el-checkbox
                    v-for="item in matchTypeOption"
                    :key="item.id"
                    :label="item.id">
                  {{item.text}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item
                label="排序"
                class="flex align-center"
                style="margin-bottom: 0;padding-left: 12px;height: 40px;border-top: 1px solid #EBEEF5">
              <gj-select
                  v-model="sortValue"
                  :options="[
                      {id:'CONVERSIONS',text:'订单数量'},
                      {id:'CLICKS',text:'点击次数'}
                  ]"
                  width="120px"
                  :filterable="false"
                  :clearable="false"
                  @change="getData(adSuggestKeyword$)">
              </gj-select>
              <gj-help style="margin-left: 8px;">
                订单数量： 关键词历史上产生的订单数<br>
                点击次数： 关键词历史上产生的点击次数
              </gj-help>
            </el-form-item>

            <gj-table
                :index="false"
                :show-pagination="false"
                :show-overflow="false"
                :adapt-height="false"
                :height="358"
                :loading="suggestKeywordLoading"
                :data="suggestKeywords"
                :columns="columns0"
                class="suggest-table">

              <template v-slot:header:keyword>
                关键词/IS/IR
                <gj-help>
                  IS：展示量份额，是指您在这个词上获得的展示量相对于它产生的所有展示量的百分比。IS为0%表示这个词您没有获得任何展示次数。<br>
                  IR：展示量排名，是指您的 IS 相对于其他广告主在同一个词上获得的展示量份额所占的排名。<br>
                  说明：利用这些指标来了解您的展示覆盖率，同时帮助您决定要设置的竞价金额。
                </gj-help>
              </template>

              <template v-slot:keyword="{ row }">
                <gj-tooltip :text-line="1" :content="row.keyword">
                  {{row.keyword | defaultShow}}
                </gj-tooltip>
                <div class="color666" style="padding: 6px 0;">{{row.localizeKeywordText | defaultShow('','','')}}</div>
                <div class="color666 flex">
                  <span style="width: 90px;">IS:{{row.impressionShare | defaultShow('','%')}}</span>
                  <span>IR:{{row.impressionRank | defaultShow}}</span>
                </div>
              </template>

              <template v-slot:matchType="{ row }">
                <div v-for="(item, i) in row.suggestBids"
                     v-show="form.matchTypes.includes(item.matchType)"
                     :key="i"
                     style="line-height: 22px;">
                  {{ item.matchType | optionText(matchTypeOption) }}
                </div>
              </template>

<!--              <template v-slot:suggestBid="{ row }">-->
<!--                <div v-for="(item, i) in row.suggestBids"-->
<!--                     :key="i"-->
<!--                     style="line-height: 22px;">-->
<!--                  {{ item.bid | defaultShow(adStore.SP.currencySymbol) }}-->
<!--                </div>-->
<!--              </template>-->

              <template v-slot:suggested="{ row }">
                <div 
                  v-for="(item, i) in row.suggestBids"
                  v-show="form.matchTypes.includes(item.matchType)"
                  :key="i"
                  style="line-height: 22px;">
                    {{ item.rangeStart ? adStore.SP.currencySymbol + item.rangeStart : '' }} 
                    - {{ item.suggested ?  adStore.SP.currencySymbol + item.suggested : '' }}
                    - {{ item.rangeEnd ?  adStore.SP.currencySymbol + item.rangeEnd : '' }}
                </div>
              </template>

              <template v-slot:header:op>
                <gj-button type="text" @click="addAllItem()">添加全部</gj-button>
              </template>

              <template v-slot:op="{ index, row }">
                <div 
                  v-for="(item, i) in row.suggestBids"
                  :key="i"
                  v-show="form.matchTypes.includes(item.matchType)">
                  <gj-button
                    type="text"
                    :disabled="item.btnDisabled"
                    style="padding: 0; line-height: 22px;"
                    @click="addItem(index, {keyword: row.keyword,impressionShare:row.impressionShare,impressionRank:row.impressionRank,localizeKeywordText:row.localizeKeywordText, ...item})">
                    添加
                  </gj-button>
                </div>
              </template>
            </gj-table>
          </el-tab-pane>
<!--          输入关键词-->
          <el-tab-pane label="输入关键词" name="second">
            <div class="match-type-form" style="padding: 0 12px">
              <el-form-item
                  label="匹配类型"
                  prop="inputMatchTypes"
                  :rules="[
                    { required: true, message: '请选择匹配类型', trigger: ['change'] }
                  ]"
                  style="margin-bottom: 10px;">
                <el-checkbox-group v-model="form.inputMatchTypes">
                  <el-checkbox
                      v-for="item in matchTypeOption"
                      :key="item.id"
                      :label="item.id">
                    {{item.text}}
                  </el-checkbox>
                </el-checkbox-group>
                <!-- <gj-select
                    v-model="form.matchType"
                    :options="matchTypeOption"
                    width="140px"
                    :clearable="false"
                    placeholder="请选择">
                </gj-select> -->
              </el-form-item>
              <div style="margin-bottom: 10px;">
                <gj-textarea
                    v-model="keyword"
                    :styles="{ height: '332px', fontSize: '12px', 'border-color': this.errorKeyword ? '#F56C6C' : '' }"
                    placeholder="请选择关键词，一行一个，回车换行">
                </gj-textarea>
              </div>
              <el-row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  class="gj-picker__editor--footer">
                <span :class="{red: errorKeyword}">关键词不得包含特殊字符，如@、#、*和$等</span>
                <!---->
                <gj-button
                    type="primary"
                    @click="addKeyword"
                    :loading="addLoading"
                    :disabled="!isMeaningful(keyword)"
                >添加</gj-button>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
<!--      右边-->
      <div class="gj-picker__table" :style="{width}">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :show-overflow="false"
            :adapt-height="false"
            :height="442"
            :data="form.items"
            :columns="columns">

          <template v-slot:header:keyword>
            关键词/IS/IR
            <gj-help>
              IS：展示量份额，是指您在这个词上获得的展示量相对于它产生的所有展示量的百分比。IS为0%表示这个词您没有获得任何展示次数。<br>
              IR：展示量排名，是指您的 IS 相对于其他广告主在同一个词上获得的展示量份额所占的排名。<br>
              说明：利用这些指标来了解您的展示覆盖率，同时帮助您决定要设置的竞价金额。
            </gj-help>
          </template>

          <template v-slot:keyword="{ row }">
            <gj-tooltip :text-line="1" :content="row.keyword">
              {{row.keyword | defaultShow}}
            </gj-tooltip>
            <div class="color666" style="padding: 6px 0;">{{row.localizeKeywordText | defaultShow('','','')}}</div>
            <div class="color666 flex">
              <span style="width: 90px;">IS:{{row.impressionShare | defaultShow('','%')}}</span>
              <span>IR:{{row.impressionRank | defaultShow}}</span>
            </div>
          </template>

          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['blur', 'change'] },
                  $gjReRule(RE.num(2), '请输入两位小数正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].bid"
                  size="mini"
                  width="113px">
                <template #prepend>{{adStore.SP.currencySymbol}}</template>
              </gj-input>
            </el-form-item>
          </template>

          <template v-slot:suggested="{ row }">
            <gj-button type="text" @click="applicationFn('item', row)">{{ row.suggested  | defaultShow(adStore.SP.currencySymbol) }}</gj-button>
          </template>

          <template v-slot:header:application>
            <gj-button type="text" @click="applicationFn('all')">全部应用</gj-button>
          </template>

          <template v-slot:application="{ row }">
            {{ row.rangeStart ? adStore.SP.currencySymbol +  row.rangeStart : ""}}
               - 
            {{ row.rangeEnd ? adStore.SP.currencySymbol +  row.rangeEnd : ""}}
          </template>

          <template v-slot:header:op>
            <gj-button type="text" @click="deleteAllItem()">全部移除</gj-button>
          </template>

          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
  </el-form>
</template>

<script>
  import { formMixin, formRuleMixin, isMeaningfulMixin } from "@/minxins";
  import {adKeywordTranslation} from "../../../../../common/mixin";
  import { isMeaningful, unique } from "@/utils/common";
  import { adStoreMixin } from "modules/ad/common/mixin";
  import { AdKeywordEnum } from "modules/ad/common/enum";
  import { rankRecommendation } from "@/api/ad";

  export default {
    name: "app-keyword-picker",
    mixins: [ adStoreMixin, isMeaningfulMixin, formMixin, formRuleMixin, adKeywordTranslation ],
    props: {
      marketId: {
        required: true,
      },
      title: {
        required: true,
      },
      bidInput: {
        type: Boolean,
        default: false,
      },
      bidLabelWidth: {
        type: String,
        default: '150px'
      },
      matchTypeOption: {
        required: true
      },
      width: {
        type: String,
        default: '500px'
      },
      adSuggestKeyword$: {
        required: true
      },
      formBase: {
        default:() => {}
      },
      // 是否显示建议竞价
      showSuggestedBidding: {
        type: Boolean,
        default: false
      }
    },
    created() {
      // this.columns[0].header = this.title;
      // if (!this.showSuggestedBidding) {
      //   this.columns0.splice(2, 1)
      //   this.columns.splice(2, 2)
      // }
    },
    data() {
      return {
        sortValue:'CONVERSIONS',//排序方式
        suggestKeywords: [],
        suggestKeywordLoading: false,
        addLoading: false,
        AdKeywordEnum: AdKeywordEnum,
        keyword: null,
        columns0: [
          {id: 'keyword', header: 'slot:keyword', field: 'slot:keyword', minWidth: '160px'},
          {id: 'matchType', header: '匹配类型', field: 'slot:matchType', width: '73px'},
          {id: 'suggested', header: '建议竞价', field: 'slot:suggested', width: '210px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '70'},
        ],
        columns: [
          {id: 'keyword', header: 'slot:keyword', field: 'slot:keyword', minWidth: '170px'},
          {id: 'matchType', header: '匹配类型', field: 'matchTypeText', width: '70px'},
          {id: 'suggested', header: '建议竞价', field: 'slot:suggested', width: '70px'},
          {id: 'application', header: 'slot:application', field: 'slot:application', minWidth: '110px'},
          {id: 'bidding', header: '关键词竞价', field: 'slot:bid', width: '125px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '75'},
        ],
        errorKeyword: false,
        keywordStyle: {height: '292px'}
      }
    },
    watch: {
      keyword(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      },
      //监听传入请求接口和参数的变化
      adSuggestKeyword$: {
        handler(adSuggestKeyword$) {
          if (isMeaningful(adSuggestKeyword$)) {
            this.suggestKeywordLoading = true;
            this.getData(adSuggestKeyword$)
          }
        },
        immediate: true,
        deep:true
      }
    },
    methods: {
      getData(adSuggestKeyword$){
        this.suggestKeywordLoading = true;
        //调用建议关键词请求接口，拼接参数
        adSuggestKeyword$.getData({
          ...adSuggestKeyword$.params,
          sortDimension:this.sortValue,//排序枚举
        })
            .then((data) => {
              this.suggestKeywords = data.data;

              if(this.suggestKeywords.length>0){
                this.suggestKeywords.forEach(r => {
                  if(isMeaningful(r.impressionShare)){
                    r.impressionShare = parseFloat(r.impressionShare).toFixed(2);
                    r.impressionShare = r.impressionShare>0?r.impressionShare:'低于0.01'
                  }
                })
                // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
                // 需从混入或者prop中获取 marketId
                this.getKeywordsInterpret(this.suggestKeywords)
              }
              // this.suggestKeywords = data.map(e => ({
              //   keyword: e.keywordText,
              //   suggestBids: this.form.matchTypes.map(matchType => ({
              //     matchType,
              //     btnDisabled: false,
              //     rangeEnd: e.rangeEnd,
              //     rangeStart: e.rangeStart,
              //     recommendedBid: e.recommendedBid,
              //   }))
              // }));
              this.refreshBtnDisable()
            })
            .complete((() => this.suggestKeywordLoading = false));
      },
      // 关键词应用
      applicationFn(type, row) {
        const opt = {
          all:()=> {
            this.form.items.forEach(item => {
              item.bid = item.suggested
            })
          },
          item: () => {
            row.bid = row.suggested
          },
        }
        opt[type]()
      },
      // 设置表格列
      setColumns() {},
      // 输入--添加关键词
      addKeyword() {
        if (!this.form.inputMatchTypes || this.form.inputMatchTypes.length === 0) {
          this.$message.error("添加ASIN失败：请先选择匹配类型")
          return false
        }
        // if (!this.showSuggestedBidding) {
        //   const keywords = [];
        //   this.keyword.split('\n')
        //     .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
        //     .filter(item => isMeaningful(item) && !/\n+/.test(item))
        //     .forEach(item => {
        //       this.form.inputMatchTypes.forEach(match => {
        //         keywords.push({
        //           keyword: item,
        //           matchTypeText: this.matchTypeOption.find(e => e.id === match).text,
        //           matchType: match,
        //           bid: this.form.bid,
        //         });
        //       })
        //     });
        //   this.form.items = unique(this.form.items.concat(keywords), ['keyword', 'matchType']);
        //   this.keyword = null;
        //   this.refreshBtnDisable();
        //   return false
        // }
        if (this.formBase&&!this.formBase.campaignId) {
          this.$message.error("添加ASIN失败：请先选择广告活动")
          return false
        }
        if (this.formBase&&!this.formBase.groupId) {
          this.$message.error("添加ASIN失败：请先选择广告组")
          return false
        }
        // 有广告活动组合获取建议竞价
        let keywords = [];
        this.keyword.split('\n')
          .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
          .filter(item => isMeaningful(item) && !/\n+/.test(item))
          .forEach(keywordText => {
            this.form.inputMatchTypes.forEach(match => {
              keywords.push({
                keywordText,
                matchType: match.toString(),
              });
            })
          });
          this.bidRefresh(keywords)
        // this.form.items = unique(this.form.items.concat(keywords), ['keyword', 'matchType']);
        // this.keyword = null;
        // this.refreshBtnDisable();
      },

      // 获取建议竞价
      async bidRefresh(keywords) {
        this.addLoading = true
        let params = {
          marketId: this.marketId,
          keywords
        }
        //新增广告活动--传asins
        if(!this.showSuggestedBidding){
          params.asins = this.adSuggestKeyword$.params.asins;
        }
        // 新增关键词--传两个id
        else {
          params.campaignId = this.formBase.campaignId;
          params.groupId = this.formBase.groupId;
        }
        try {
          let { data } = await rankRecommendation(params)
            let keywordsMap = []
            data.forEach(e => {
              e.suggestBids.forEach(r =>{
                if(isMeaningful(e.impressionShare)){
                  e.impressionShare = parseFloat(e.impressionShare).toFixed(2);
                  e.impressionShare = e.impressionShare>0?e.impressionShare:'低于0.01'
                }
                // this.form.inputMatchTypes.forEach(match => {
                  keywordsMap.push({
                    impressionRank:e.impressionRank,
                    impressionShare:e.impressionShare,
                    keyword: e.keyword,
                    matchTypeText: this.matchTypeOption.find(e => e.id === r.matchType).text,
                    matchType: r.matchType,
                    bid: this.form.bid,
                    rangeEnd: r.rangeEnd,
                    rangeStart: r.rangeStart,
                    suggested: r.suggested,
                  })
                // })
              })
            })
          // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
          // 需从混入或者prop中获取 marketId
          if(keywordsMap.length>0){
            await this.getKeywordsInterpret(keywordsMap)
          }
            this.form.items = unique(this.form.items.concat(keywordsMap), ['keyword', 'matchType']);
            this.keyword = null;
            this.refreshBtnDisable();

        } finally {
          this.addLoading = false
        }
      },
      addAllItem() {
        const data = this.suggestKeywords.map(e => {
          return this.mapTo(e.keyword, e.suggestBids, e);
        }).reduce((e1, e2) => e1.concat(e2), []).filter(item => {
          return this.form.matchTypes.indexOf(item.matchType) > -1;
        })
        this.addKeywords(data);
      },
      mapTo(keyword, suggestBids, e) {
        return suggestBids.map(e => ({
          ...e,
          keyword,
          matchTypeText: this.matchTypeOption.find(e1 => e1.id === e.matchType).text,
          matchType: e.matchType,
          bid: this.form.bid
        }));
      },
      addItem(index, row) {
        this.addKeywords([{
          ...row,
          keyword: row.keyword,
          localizeKeywordText:row.localizeKeywordText,
          impressionShare:row.impressionShare,
          impressionRank:row.impressionRank,
          matchTypeText: this.matchTypeOption.find(e => e.id === row.matchType).text,
          matchType: row.matchType,
          bid: this.form.bid,
        }]);
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      addKeywords(keywords) {
        this.form.items = unique(this.form.items.concat(keywords), ['keyword', 'matchType']);
        this.refreshBtnDisable();
      },
      refreshBtnDisable() {
        this.suggestKeywords
          .map(e => {
            e.suggestBids.forEach(e1 => e1.keyword = e.keyword);
            return e.suggestBids;
          })
          .reduce((e1, e2) => e1.concat(e2), [])
          .forEach(e1 => {
            if (this.form.items.some(e2 => `${e1.keyword}_${e1.matchType}` === `${e2.keyword}_${e2.matchType}`)) {
              this.$set(e1, 'btnDisabled', true);
            } else {
              this.$set(e1, 'btnDisabled', false);
            }
          });
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          if (this.form.items.length <= 0) {
            this.$gjMessage.closeAll();
            this.$gjMessage.error('请添加关键词');
            reject();
          } else {
            this.$refs.form.validate(valid => {
              valid ? resolve() : reject()
            });
          } 
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  /deep/.vxe-table--body {
    .vxe-body--row {
      .vxe-body--column {
        height: 58px !important;
      }
    }
  }
  .gj-picker__editor {
    padding: 0;
     height: 483px !important;
  }
  .gj-picker {
     height: 485px !important;
  }
  .gj-picker {
    border: 1px solid #d9d9d9;
  }
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  
  /deep/ .el-tabs__header {
    margin-bottom: 5px !important;
  }
  
  /deep/ .el-radio__label,
  /deep/ .el-checkbox__label {
    font-size: 12px;
  }
  
  .suggest-table {
    border-top: 1px solid #EBEEF5;
  }

  /deep/.vxe-cell {
    &.c--ellipsis {
        max-height: 300px !important;
        overflow: visible !important;
        text-overflow: ellipsis !important;
        white-space: normal !important;
    }
  }
  .match-type-form {
    /deep/.el-form-item__error {
      top: 77% !important;
    }
  }
  /*.suggest-table.gj-table /deep/ td .cell {*/
  /*  padding-top: 8px;*/
  /*  padding-bottom: 8px;*/
  /*}*/
</style>
